import React, { useState } from 'react';
import { Container, TabContent, TabPane } from 'reactstrap';
import OfferCard from './components/OfferCard';
import { OfferState } from './context';
import { partial } from '../../util/translation/translation';
import NavTab from '../../shared/components/custom/NavTab';
import OffersShowcase from './components/OffersShowcase';

const OffersPage = () => {
  const f = partial('OffersPage');
  const [tab, setTab] = useState('1');
  const [offerStatus, setOfferStatus] = useState('active');
  return (
    <Container>
      <OffersShowcase />
      <NavTab
        activeTab={tab}
        tabs={[f('offers')]}
        setTab={(activeTab) => setTab(activeTab)}
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <OfferState>
            <OfferCard status={offerStatus} onStatusChange={setOfferStatus} />
          </OfferState>
        </TabPane>
      </TabContent>
    </Container>
  );
};
export default OffersPage;
